import { Search2Icon } from "@chakra-ui/icons";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { useTranslatedString } from "src/i18n/hooks";
import { useSearchContext } from "./hooks";

export const SearchInput = () => {
	const { state } = useSearchContext();
	const t = useTranslatedString();
	const [value, setValue] = useState(state.query);
	const searchParams = useSearchParams();
	const searchTerm = searchParams.get("searchTerm");
	const router = useRouter();

	const startSearch = (value: string) => {
		setValue(value);

		if (value.length >= 3 || value.length === 0) {
			state.setQuery(value);
		}
	};

	useEffect(() => {
		// Sync logic: URL param takes priority, then fallback to context state
		// Priority: searchTerm (URL) > state.query > current value
		const targetValue = searchTerm ?? state.query;

		// Update local input value if it differs from target
		if (targetValue !== value) {
			setValue(targetValue);
		}

		// Update shared context state if it differs from target
		if (targetValue !== state.query) {
			state.setQuery(targetValue);
		}

		// Clean up: remove URL param after consuming it (one-time handoff)
		// This prevents infinite loops and keeps URL clean
		if (searchTerm) {
			router.replace(`/${t("search.slug")}`, { scroll: false });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchTerm, state.query]);

	return (
		<div className="flex gap-4 max-w-container mx-auto">
			<label htmlFor="search" className="sr-only">
				{t("search.placeholder")}
			</label>
			<div className="relative w-full">
				<input
					id="search"
					type="search"
					placeholder={t("search.placeholder")}
					value={value}
					onChange={(event) => startSearch(event.target.value)}
					onKeyDown={(event) =>
						event.key === "Enter" && startSearch(value)
					}
					className="bg-white w-full py-2 rounded-md border-brand-light border
  focus-visible:ring-2 focus-visible:ring-brand-highlight
  focus-visible:outline-hidden pl-14 px-4 h-12"
				/>
				<div className="border-r border-r-brand-light absolute top-0 left-0 h-full flex justify-center items-center w-12">
					<Search2Icon className="size-5!" />
				</div>
			</div>
		</div>
	);
};

// 🔬 TBD
